import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const instrumentReliabilityListDuck = makeReportingDuck(
  'instrumentReliability',
  (filters) => getPaginated('/reports/instrument-reliability/', filters),
  () => getApi('/reports/instrument-reliability/info/')
);

export type InstrumentReliabilityAction = ReportingDuckActions<
  typeof instrumentReliabilityListDuck
>;
